<template>
  <div>
    <app-navigation isHome="false"/>

    <app-heading-image/>

    <div class="max-width-4 mt3 mx-auto content-wrapper clearfix">
      <div class="md-col-8 sm-col-12 pr1 mx-auto clearfix">
        <div class="col-12">
          <h1 class="h1 headline hide">PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer</h1>
          <h2 class="h1 headline hide">Klinischer Psychologe. Gesundheitspsychologe</h2>

          <app-paragraph id="klinische-diagnostik" headline="Klinische Diagnostik">
            Die klinische Psychologie beschäftigt sich mit Ursachen und Auswirkungen von psychischen
            Belastungen und Störungen. Bei der klinisch-psychologischen Diagnostik werden durch
            Exploration, Anamnese, Testverfahren und Verhaltensbeobachtungen Informationen
            gesammelt, um die passende Behandlungsmöglichkeit zu finden.
          </app-paragraph>

          <app-paragraph id="behandlung-und-beratung" headline="Behandlung & Beratung">
            Die klinisch-psychologischen Behandlung hat das Ziel, Krankheiten vorzubeugen sowie
            psychische Leidenszustände zu lindern oder zu beseitigen. Ich unterstütze Menschen
            dabei, ihre Probleme oder Krankheiten zu bewältigen. Die Behandlung setzt konkret an den
            jeweiligen Störungen oder dem Problem an. Dabei kommen regelmäßig Methoden der
            Psychoedukation, gezielte Behandlungsprogramme sowie Entspannungsverfahren zur
            Anwendung. Bei der klinisch-psychologischen Beratung stelle ich Informationen und
            Entscheidungshilfen zur Verfügung, die dabei unterstützen, passende Lösungsmöglichkeiten
            zu finden.
          </app-paragraph>

          <app-paragraph id="befunde-und-gutachten" headline="Befunde & Gutachten">
            Klinisch-psychologische Befunde stellen die Ergebnisse einer klinisch-psychologischen
            Untersuchung/Diagnostik dar und beruhen meist auf einer Verdachtsdiagnose oder einer
            entsprechenden Fragestellung. Im klinisch-psychologischen Gutachten beantworte ich
            nachvollziehbar und schlüssig genau festgelegte Fragestellungen aus dem Bereich der
            klinischen und Gesundheitspsychologie. Dies erfolgt auf Basis von erhobenen Befunden,
            meines Fachwissens-beruhend auf dem aktuellen Forschungsstand sowie der Berufserfahrung
            und Reflexion von Alltagserfahrungen. Befunde als auch Gutachten dienen zur Vorlage an
            Ärzte, Fachkollegen, Behörden, Gerichte und andere Auftraggeber und bilden deren
            Entscheidungsgrundlage. Als Beispiel seien hier etwa Fragestellungen zur
            Zurechnungsfähigkeit von Personen, Feststellung der psychologischen Belastbarkeit bzw.
            Leistungsfähigkeit, Entwicklungsstand von Kindern oder Jugendlichen, Klärung von Selbst-
            oder Fremdgefährdung oder auch die Verlässlichkeitsprüfung gem. Waffengesetz zur
            Erlangung von Waffenbesitzkarte oder Waffenpass, angeführt.
          </app-paragraph>

          <app-paragraph id="sportpsychologie" headline="Sportpsychologie">
            Die Sportpsychologie ist einer von vielen speziellen Bereichen im Feld der Psychologie
            und verlangt zumindest ein abgeschlossenes Studium der Psychologie. Aufgrund meiner
            eigenen, langjährigen Erfahrungen im Bereich des Leistungssports, ist das Thema für mich
            sehr interessant und ich kann hier individuelle und kompetente Hilfe für
            Leistungssteigerungen bieten. Beispielsweise wären dies Training der
            Konzentrationsfähigkeit, Entspannungstechniken, Visualisierung, Autogenes Training,
            Umgang mit sportlichen Krisen u. v. m. Da im Leistungssport aber auch Trainer öfters an
            ihre Belastungsgrenzen kommen, wäre es sinnvoll wenn auch diese Gruppe der
            Sportbegeisterten psychologische Beratung in Anspruch nehmen würde.
          </app-paragraph>

          <app-paragraph id="notfallpsychologie" headline="Notfallpsychologie">
            Hier geht es mir um die Akutbetreuung bei außergewöhnlich belastenden Ereignissen,
            welche oft auch potentiell traumatisierenden Charakter aufweisen können. Dies betrifft
            beispielsweise erlebte schwere Unfälle, den Tod von geliebten Menschen,
            Missbrauchserfahrungen, erlebte Gewalt oder auch Katastrophenereignisse. Die Betreuung
            richtet sich nach den Bedürfnissen des direkt Betroffenen, aber auch der
            Familienangehörigen, wenn dies nötig sein sollte. Notfallpsychologische Hilfe gibt den
            Betroffenen in der Krisensituation Halt, Unterstützung und Struktur, um möglichst bald
            mit der Bewältigung zu beginnen und um mögliche Folgeerscheinungen des erlittenen
            Traumas besser kontrollieren oder auch verhindern zu können.
          </app-paragraph>

          <app-paragraph id="supervision" headline="Supervision">
            Supervision (lateinisch: Über-Blick) ist eine Form der Beratung für Mitarbeiter oder
            Fachkollegen, die zur Reflexion des eigenen Handelns anregen und die Qualität
            professioneller Arbeit sichern und verbessern soll. Aufgrund meiner Kompetenzen und
            Berufserfahrung biete ich allen Interessierten aus dem psychosozialen Bereich, wie
            klinischer Psychologie, Gesundheitspsychologie, Studenten der Psychologie,
            Sozialpädagogen, Sozialarbeiter u. a. psychologische Beratung an.
          </app-paragraph>

        </div>
      </div>
    </div>

    <app-contact />

    <app-partners />
  </div>
</template>

<script>
import AppHeadingImage from '../components/HeadingImage'
import AppPartners from '../components/Partners'
import AppContact from '../components/Contact'

export default {
  name: 'Home',
  components: {
    'app-heading-image': AppHeadingImage,
    'app-partners': AppPartners,
    'app-contact': AppContact
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue